import React, { useEffect, useRef } from "react";
import { Wrapper } from "@googlemaps/react-wrapper";

const MapComponent = ({ center, zoom }) => {
  const mapRef = useRef(null);

  // Dynamic location data
  const locationData = {
    shortName: "Martin Professional ME",
    fullName: "Martin Professional Middle East (MPME)",
    description:
      "Leading provider of professional lighting solutions in the Middle East region, specializing in entertainment, architectural, and commercial lighting systems.",
    address: "Dubai, United Arab Emirates",
  };

  useEffect(() => {
    if (mapRef.current) {
      const map = new window.google.maps.Map(mapRef.current, {
        center,
        zoom,
        disableDefaultUI: true,
        zoomControl: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        gestureHandling: "none",
        styles: [
          {
            featureType: "road",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "landscape",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "water",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            elementType: "labels.text",
            stylers: [{ visibility: "off" }],
          },
        ],
      });

      // Create custom marker
      const marker = new window.google.maps.Marker({
        position: center,
        map: map,
        title: "Martin Professional Middle East (MPME)",
        icon: {
          url:
            "data:image/svg+xml;charset=UTF-8," +
            encodeURIComponent(`
            <svg xmlns="http://www.w3.org/2000/svg" width="200" height="40" viewBox="0 0 200 40">
              <text x="10" y="30" font-family="Arial, sans-serif" font-size="24" fill="#e74c3c">📍</text>
              <text x="40" y="25" font-family="Arial, sans-serif" font-size="14" font-weight="bold" fill="#333">${locationData.shortName}</text>
            </svg>
          `),
          scaledSize: new window.google.maps.Size(200, 40),
          anchor: new window.google.maps.Point(100, 40),
        },
      });

      // Add info window
      const infoWindow = new window.google.maps.InfoWindow({
        content:
          "<div><strong>Martin Professional Middle East (MPME)</strong></div>",
      });

      marker.addListener("click", () => {
        infoWindow.open(map, marker);
      });
    }
  }, [center, zoom]);

  return (
    <div className="relative" style={{ height: "600px", width: "100%" }}>
      <div ref={mapRef} style={{ height: "100%", width: "100%" }} />
      {/* Info Box */}
      <div className="absolute top-4 left-4 bg-white p-4 rounded-lg shadow-lg z-10 max-w-xs">
        <h3 className="font-bold text-lg mb-2">{locationData.shortName}</h3>
        <div className="text-sm text-gray-600 mb-3">
          <p className="mb-2">{locationData.description}</p>
          <p>
            <strong>Location:</strong> {locationData.address}
          </p>
        </div>
        <a
          href="https://www.google.com/maps/place/Martin+Professional+Middle+East+(MPME)/@25.1458872,55.2241559,17z/data=!3m1!4b1!4m6!3m5!1s0x3e5f428c7bb3c941:0x311681a30aa3e8d7!8m2!3d25.1458872!4d55.2241559!16s%2Fg%2F11bbwp3_jy?entry=ttu&g_ep=EgoyMDI1MDYwOC4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors text-sm"
        >
          View on Google Maps
        </a>
      </div>
    </div>
  );
};

const Map = () => {
  const position = { lat: 25.1458872, lng: 55.2241559 }; // Coordinates for the map center
  const API_KEY = "AIzaSyDoX-3PIgWhDS1wvlcl2s66r6XCHjG0ztc";

  const render = (status) => {
    if (status === "LOADING") return <div>Loading...</div>;
    if (status === "FAILURE") return <div>Error loading map</div>;
    return null;
  };

  return (
    <section className="scroll-section flex items-center justify-center flex-1">
      <Wrapper apiKey={API_KEY} render={render}>
        <MapComponent center={position} zoom={12} />
      </Wrapper>
    </section>
  );
};

export default Map;
